// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__a_c7r","container--collapsed":"styles_container--collapsed__xnDF8","skeleton-animation":"styles_skeleton-animation__9Mc87"};